import { type ReactNode } from "react";
import Image from "next/image";
import classNames from "classnames";

type GiftOptionTileProps = {
  name: string;
  author?: string;
  imageSrc?: string;
  /** The checkbox or radio. Without one the tile only shows what is in the package. */
  control?: ReactNode;
  inputId?: string;
  isSelected?: boolean;
  isDisabled?: boolean;
};

export const GiftOptionTile = ({
  name,
  author,
  imageSrc,
  control,
  inputId,
  isSelected = false,
  isDisabled = false,
}: GiftOptionTileProps) => {
  const isSelectable = Boolean(control);
  const Wrapper = isSelectable ? "label" : "div";

  return (
    <Wrapper
      htmlFor={isSelectable ? inputId : undefined}
      className={classNames(
        "relative flex h-full flex-col gap-2 rounded-xl border-2 bg-white p-3 transition-colors",
        isSelectable && isSelected ? "border-black" : "border-stroke-default",
        {
          "cursor-pointer": isSelectable && !isDisabled,
          "hover:border-black": isSelectable && !isSelected && !isDisabled,
          "cursor-not-allowed opacity-50": isDisabled,
        },
      )}
    >
      <span className="relative block aspect-square w-full sm:aspect-[4/3]">
        {imageSrc ? (
          <Image
            src={imageSrc}
            alt=""
            fill
            sizes="(min-width: 768px) 240px, 45vw"
            className="object-contain"
          />
        ) : null}
      </span>
      {control ? (
        <span className="absolute top-2 right-2 flex rounded-md bg-white">
          {control}
        </span>
      ) : null}
      <span className="line-clamp-2 text-base leading-snug font-semibold">
        {name}
      </span>
      {author ? (
        <span className="-mt-1 truncate text-sm text-gray-700">{author}</span>
      ) : null}
    </Wrapper>
  );
};
